__webpack_require__.p = "https://eatmygoose.github.io/RatSpinner/";